export const GET_COMPANIES = "admin/companies";

export const UPDATE_COMPANY_FLAG = "admin/companies";
